<style lang="scss" scoped>
.shopping-basket {
    position: relative;

    &[data-basketsize] {
        &:after {
            content: attr(data-basketsize);
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background-color: #23b32f;
            color: #fff;
            position: absolute;
            bottom: 100%;
            left: 100%;
            font-weight: 300;
            line-height: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 10px;
            padding-bottom: 1px;
            transform: translateX(-8px) translateY(10px);
        }
    }
}
</style>

<template>
    <a href="/winkelmandje" class="shopping-basket" :data-basketsize="$store.getters['basketSize']">
        <slot></slot>
    </a>
</template>

<script>
export default {
    name: "Ui.ShoppingBasketCounter",
}
</script>